module.exports = "https://coursera_assets.s3.amazonaws.com/images/355e4eff059cdc00f0009735eca9b030.jpg";